// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"afb698ed","598":"ec85d33f","703":"58258665","921":"ae74b949"}[chunkId] + ".chunk.js";
};